import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal/index.js';

// eslint-disable-next-line react/display-name
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var IconComponent = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "16",
    height: "17",
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsxs("g", {
      fill: "currentColor",
      children: [/*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.473 0A2.473 2.473 0 0 0 4 2.473v5.909l-.416-.208C1.937 7.35 0 8.548 0 10.389c0 .656.26 1.286.725 1.75l3.863 3.863L12.816 16l1.675-6.82a3 3 0 0 0-2.19-3.631l-3.356-.831V2.473A2.473 2.473 0 0 0 6.473 0ZM6 2.473a.473.473 0 0 1 .945 0v3.81L11.82 7.49a1 1 0 0 1 .73 1.21L11.248 14l-5.836-.002-3.273-3.273a.476.476 0 0 1 .55-.762L6 11.618V2.473Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M13.359 1.292A8 8 0 0 0 9.976.06l-.244 1.985a6 6 0 0 1 2.537.924c.775.504 1.432 1.17 1.839 1.98l1.787-.897c-.597-1.19-1.528-2.105-2.536-2.76Z"
      })]
    })
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export var IconActionFingerDraw16 = createIcon(IconComponent);